import React, { useState, useEffect } from 'react';
import { Container, FormGroup, Card } from 'react-bootstrap';
import { useFieldArray, useFormContext } from 'react-hook-form';
import Select from 'react-select';
import { connect, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';

function TestingSuggestion({ TestingBOMComponentFromReducer, colourWaysFromReducer, selectedType, removeSelectedTestingComponent }) {
  const {
    SystemMastersDetails: { testTypeMaster },
  } = useSelector((state) => state);

  const { control, register, errors, setValue, testLibrariesArray, testLibrariesAppend, getValues, disabledSubmitButton, suggestionEditMode } =
    useFormContext(); // retrieve all hook methods

  const noWhitespacesClass = 'no whitespaces.';

  useFieldArray({
    control,
    name: 'testLibraries',
  });
  const testTypeListArray = testTypeMaster;
  const { t } = useTranslation('common');

  const [bomComponentList, setBomComponentList] = useState([]);
  const [colourList, setColourList] = useState([]);
  const [testDescCount, setTestDescCount] = useState(0);
  const [additionalInfoCount, setAdditionalInfoCount] = useState(0);

  const onChangeTestDescCount = (e, i) => {
    const { value } = e.currentTarget;
    setTestDescCount((prev) => ({
      ...prev,
      [`testLibraries[${i}].description`]: value.length,
    }));
  };

  const onChangeAdditionalInfoCount = (e, i) => {
    const { value } = e.currentTarget;
    setAdditionalInfoCount((prev) => ({
      ...prev,
      [`testLibraries[${i}].additionalInformation`]: value.length,
    }));
  };

  // all useEffect collection
  useEffect(() => {
    setBomComponentList([]);
    TestingBOMComponentFromReducer?.forEach((item) => {
      setBomComponentList((prev) => [
        ...prev,
        {
          referenceCode: `${item.bomType.name} - ${item.referenceCode}`,
          _id: item._id,
        },
      ]);
    });
    disabledSubmitButton(false);
  }, [TestingBOMComponentFromReducer]); // eslint-disable-line

  useEffect(() => {
    setColourList(colourWaysFromReducer);
  }, [colourWaysFromReducer]);

  useEffect(() => {
    disabledSubmitButton(false);
    return () => {
      disabledSubmitButton(true);
    };
  }, []);

  const AddNewSymbol = (e) => {
    e.preventDefault();
    const totalData = testLibrariesArray.length;
    if (totalData === 0) {
      testLibrariesAppend({
        code: '',
        description: '',
        type: null,
        minPassRate: '',
        bomComponent: null,
        colour: null,
        additionalInformation: '',
        status: 'Pending',
      });
    } else {
      let filledData = 0;
      testLibrariesArray.forEach((item, i) => {
        const checkData = getValues(`testLibraries[${i}].code`).length;
        if (checkData > 0) {
          filledData += 1;
        }
      });

      if (totalData === filledData) {
        testLibrariesAppend({
          code: '',
          description: '',
          type: null,
          minPassRate: '',
          bomComponent: null,
          colour: null,
          additionalInformation: '',
          status: 'Pending',
        });
      } else {
        toasterMsg(t('TESTING_SUGGESTION.TESTING_CODE_REQUIRED'), t('TESTING_SUGGESTION.DANGER'));
      }
    }
  };

  const removeTestingLib = (item, i) => {
    removeSelectedTestingComponent(item, i);
  };

  return (
    <Container fluid>
      <Card className="mb-3 custom-card">
        <Card.Header>
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>{t('TESTING_SUGGESTION.TESTING')}</div>
            <div className="d-flex code-dropdown ml-auto">
              {selectedType && selectedType.value === 'new' && !suggestionEditMode && (
                <button className="btn btn-default" type="button" onClick={(e) => AddNewSymbol(e)}>
                  {t('TESTING_SUGGESTION.ADD_NEW')}
                </button>
              )}
            </div>
          </div>
        </Card.Header>

        <Card.Body>
          <div className="table-responsive">
            <table className="table common-custom-table xs-layout-fixed xs-table-col-150px font-13">
              <thead>
                <tr>
                  <th className="w-100px">{t('TESTING_SUGGESTION.TESTING_CODE')}</th>
                  <th className="w-200px">{t('TESTING_SUGGESTION.TESTING_DESCRIPTION')}</th>
                  <th className="w-120px">{t('TESTING_SUGGESTION.TEST_TYPE')}</th>
                  <th className="w-100px">{t('TESTING_SUGGESTION.MINIMUM_PASS_RATE')}</th>
                  <th className="w-150px">{t('TESTING_SUGGESTION.BOM_COMPONENT')}</th>
                  <th className="w-100px">{t('TESTING_SUGGESTION.COLOUR')}</th>
                  <th className="w-150px">{t('TESTING_SUGGESTION.ADDITIONAL_INFORMATION')}</th>
                  {!suggestionEditMode && <th className="w-80px">{t('TESTING_SUGGESTION.ACTION')}</th>}
                </tr>
              </thead>
              <tbody>
                {testLibrariesArray.length > 0 &&
                  testLibrariesArray.map((formItem, index) => {
                    return (
                      <tr key={formItem?._id} className={formItem.status === 'Approved' || formItem.status === 'Deleted' ? 'disabled' : ''}>
                        <td>
                          <FormGroup className="mb-0">
                            <div className="common-input-control mb-0">
                              <input
                                type="text"
                                name={`testLibraries[${index}].code`}
                                className="form-control bordered-input"
                                disabled={selectedType && selectedType.value === 'amendment'}
                                {...register(`testLibraries[${index}].code`, {
                                  required: true,
                                  validate: (value) => !!value.trim() || noWhitespacesClass,
                                })}
                              />
                            </div>
                            {errors.testLibraries?.[index]?.code && <small className="error-message">{t('TESTING_SUGGESTION.TESTING_CODE_REQUIRED')}</small>}
                          </FormGroup>
                        </td>
                        <td>
                          <FormGroup className="mb-0">
                            <div className="common-input-control mb-0">
                              <input
                                type="text"
                                name={`testLibraries[${index}].description`}
                                className="form-control bordered-input"
                                {...register(`testLibraries[${index}].description`, {
                                  required: true,
                                  maxLength: { value: 200 },
                                  validate: (value) => !!value.trim() || noWhitespacesClass,
                                })}
                                onChange={(e) => {
                                  onChangeTestDescCount(e, index);
                                }}
                              />
                            </div>
                            {(errors.testLibraries?.[index]?.description || testDescCount[`testLibraries[${index}].description`] === 0) && (
                              <small className="error-message">{t('TESTING_SUGGESTION.TESTING_DESCRIPTION_REQUIRED')}</small>
                            )}
                            <div className="d-flex w-100 position-relative">
                              {testDescCount[`testLibraries[${index}].description`] > 200 && (
                                <small className="error-message text-left">{t('TESTING_SUGGESTION.MUST_NOT_200_CHARACTER')}</small>
                              )}

                              <div className="text-right w-100 position-absolute">
                                <span className="text-success">
                                  {testDescCount[`testLibraries[${index}].description`] === undefined &&
                                  testDescCount[`testLibraries[${index}].description`] !== 0
                                    ? `${formItem.description.length}/200`
                                    : `${testDescCount[`testLibraries[${index}].description`]}/200`}
                                </span>
                              </div>
                            </div>
                          </FormGroup>
                        </td>
                        <td>
                          <FormGroup className="mb-0">
                            <div className="common-react-select mb-0 flex-fill">
                              <Select
                                name={`testLibraries[${index}].type`}
                                {...register(`testLibraries[${index}].type`, {
                                  required: true,
                                })}
                                options={testTypeListArray}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) => `${option.name}`}
                                onChange={(val) => {
                                  setValue(`testLibraries[${index}].type`, val._id, {
                                    shouldValidate: true,
                                  });
                                  return { value: val._id };
                                }}
                                defaultValue={
                                  formItem?.type?.name && {
                                    name: formItem?.type?.name,
                                  }
                                }
                                menuPosition="fixed"
                                maxMenuHeight={132}
                                menuShouldBlockScroll
                                menuShouldScrollIntoView
                                className="common-select"
                                classNamePrefix="common-select"
                                placeholder={t('TESTING_SUGGESTION.SELECT_TEST_TYPE')}
                              />
                            </div>

                            {errors.testLibraries?.[index]?.type && <small className="error-message">{t('TESTING_SUGGESTION.TEST_TYPE_REQUIRED')}</small>}
                          </FormGroup>
                        </td>
                        <td>
                          <FormGroup className="mb-0">
                            <div className="common-input-control mb-0">
                              <input
                                type="text"
                                name={`testLibraries[${index}].minPassRate`}
                                className="form-control bordered-input"
                                {...register(`testLibraries[${index}].minPassRate`, {
                                  required: true,
                                  validate: (value) => !!value.trim() || noWhitespacesClass,
                                })}
                                // defaultValue={formItem.productName}
                              />
                            </div>
                            {errors.testLibraries?.[index]?.minPassRate && (
                              <small className="error-message">{t('TESTING_SUGGESTION.MINIMUM_PASS_RATE_REQUIRED')}</small>
                            )}
                          </FormGroup>
                        </td>
                        <td>
                          <FormGroup className="mb-0">
                            <div className="common-react-select mb-0 flex-fill">
                              <Select
                                name={`testLibraries[${index}].bomComponent`}
                                {...register(`testLibraries[${index}].bomComponent`)}
                                options={bomComponentList}
                                getOptionLabel={(option) => `${option.referenceCode}`}
                                getOptionValue={(option) => `${option._id}`}
                                onChange={(selected) => {
                                  setValue(`testLibraries[${index}].bomComponent`, selected, {
                                    shouldValidate: true,
                                  });
                                  return { value: selected };
                                }}
                                defaultValue={
                                  formItem?.bomComponent?._id && {
                                    referenceCode: formItem.bomComponent?.referenceCode,
                                    _id: formItem.bomComponent?._id,
                                  }
                                }
                                menuPosition="fixed"
                                maxMenuHeight={132}
                                menuShouldBlockScroll
                                menuShouldScrollIntoView
                                className="common-select"
                                classNamePrefix="common-select"
                                placeholder={t('TESTING_SUGGESTION.BOM_COMPONENT')}
                              />
                            </div>
                          </FormGroup>
                        </td>
                        <td>
                          <FormGroup className="mb-0">
                            <div className="common-react-select mb-0 flex-fill">
                              <Select
                                name={`testLibraries[${index}].colour`}
                                {...register(`testLibraries[${index}].colour`)}
                                options={colourList}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) => `${option._id}`}
                                onChange={(selected) => {
                                  setValue(`testLibraries[${index}].colour`, selected, {
                                    shouldValidate: true,
                                  });
                                  return { value: selected };
                                }}
                                defaultValue={
                                  formItem.colour && {
                                    name: formItem.colour?.name,
                                    _id: formItem.colour?._id,
                                  }
                                }
                                menuPosition="fixed"
                                maxMenuHeight={132}
                                menuShouldBlockScroll
                                menuShouldScrollIntoView
                                className="common-select"
                                classNamePrefix="common-select"
                                placeholder={t('TESTING_SUGGESTION.COLOUR')}
                              />
                            </div>
                          </FormGroup>
                        </td>
                        <td>
                          <FormGroup className="mb-0">
                            <div className="common-input-control mb-0">
                              <input
                                type="text"
                                name={`testLibraries[${index}].additionalInformation`}
                                className="form-control bordered-input"
                                {...register(`testLibraries[${index}].additionalInformation`, {
                                  required: false,
                                  maxLength: { value: 200 },
                                })}
                                onChange={(e) => {
                                  onChangeAdditionalInfoCount(e, index);
                                }}
                              />
                            </div>
                            <div className="d-flex w-100 position-relative">
                              {additionalInfoCount[`testLibraries[${index}].additionalInformation`] > 200 && (
                                <small className="error-message text-left">{t('TESTING_SUGGESTION.MUST_NOT_200_CHARACTER')}</small>
                              )}

                              <div className="text-right w-100 position-absolute">
                                <span className="text-success">
                                  {additionalInfoCount[`testLibraries[${index}].additionalInformation`] === undefined &&
                                  additionalInfoCount[`testLibraries[${index}].additionalInformation`] !== 0
                                    ? `${formItem?.additionalInformation?.length || 0}/200`
                                    : `${additionalInfoCount[`testLibraries[${index}].additionalInformation`]}/200`}
                                </span>
                              </div>
                            </div>
                          </FormGroup>
                        </td>
                        {!suggestionEditMode && (
                          <td className="text-center">
                            <button
                              className="border-0 btn-lelete-lib"
                              disabled={testLibrariesArray.length === 1}
                              type="button"
                              aria-label={t('TESTING_SUGGESTION.DELETE')}
                              onClick={() => {
                                removeTestingLib(formItem, index);
                              }}
                            >
                              <span className="icon-Delete f-20" />
                            </button>
                          </td>
                        )}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}

const mapStateToProps = ({ SupplierSuggestion }) => {
  const { testingBOMComponent, colourWays, TestingLibraryFormData } = SupplierSuggestion;
  return {
    TestingBOMComponentFromReducer: testingBOMComponent,
    colourWaysFromReducer: colourWays,
    TestingLibraryFormDataFromReducer: TestingLibraryFormData,
  };
};

const mapStateToDispatch = {};

export default connect(mapStateToProps, mapStateToDispatch)(TestingSuggestion);
